import { render, staticRenderFns } from "./RecurringRemarkListView.vue?vue&type=template&id=913e5344"
import script from "./RecurringRemarkListView.vue?vue&type=script&lang=js"
export * from "./RecurringRemarkListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports